/************************************** Request related errors **************************************/
const ERROR_ACCEPTED_REQUEST = {error: true, code: 'REQ_ACC', message: 'Request already accepted'};
const ERROR_REQUEST_NOT_EXIST = {error: true, code: 'REQ_NA', message: 'Request does not exist'};
/************************************** Request related errors **************************************/

/************************************** Payment related errors **************************************/
const ERROR_COMMISSION_PMT_FAILED = {error: true, code: 'COMM_PMT_FAIL', message: 'Commission payment failed'};
/************************************** Payment related errors **************************************/

/************************************** Generic errors **************************************/
const ERROR_GENERAL = {error: true, code: 'GEN', message: 'An error occurred'};
/************************************** Generic errors **************************************/


module.exports = {
    ERROR_ACCEPTED_REQUEST,
    ERROR_REQUEST_NOT_EXIST,
    ERROR_COMMISSION_PMT_FAILED,
    ERROR_GENERAL
}